import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as TimeSvg } from "@/svgs/time.svg?react";

export default function TimeIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={TimeSvg} inheritViewBox />;
}
